import Vuex from "vuex";

export interface SharedStore {
  anwendungslisteChangedTrigger: number;
}

export default new Vuex.Store({
  state: {
    anwendungslisteChangedTrigger: 0
  } as SharedStore,
  mutations: {
    triggerAnwendungslisteChanged(state) {
      state.anwendungslisteChangedTrigger = state.anwendungslisteChangedTrigger + 1
    }
  },
  actions: {},
  modules: {}
});
